<template>
  <transition-group tag="div" name="notification-list" class="notifications">
    <notification-item
      v-for="item in notifications"
      :key="item.id"
      class="notification-item"
      :item="item"
    />
  </transition-group>
</template>

<script>
import { mapState } from 'vuex'
import NotificationItem from './NotificationItem.vue'

export default {
  components: { NotificationItem },
  computed: mapState({
    notifications: (state) => state.notifications.items,
  }),
}
</script>

<style lang="scss">
.notification-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.notification-list-enter,
.notification-list-leave-to {
  opacity: 0;
}

.notification-list-enter {
  transform: translateY(100%);
}
.notification-list-leave-to {
  transform: translateY(-100%);
}
.notifications-list-leave-active {
  position: absolute;
}
</style>
